// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunks/css/" + chunkId + "." + {"node_modules_jsmdg_yoshi_dist_components_Modal_Modal_module_scss": "23d4bb41","node_modules_jsmdg_yoshi_dist_features_NewProductTile_ProductTileImageSlider_index_js-node_mo-1ce880": "6756ea70","vendors-node_modules_swiper_modules_a11y_css-node_modules_swiper_modules_navigation_css-node_-3c9ad9": "999d177c",}[chunkId] + ".css"
}